module.exports = __webpack_public_path__ + "img/Large-2-Bevel-Attachment-16.7480b62b.png";